"use client";
import React from "react";
import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

const features = [
  "Customizable question banks",
  "Multi-format exam options (MCQ, descriptive, blended)",
  "Real-time analytics",
  "Advanced biometric registration & authentication",
  "AI-driven cheating prevention",
  "Encrypted data transmission",
  "Cloud-based infrastructure ensures scalability",
];

const advantages = [
  "Guarantees exam integrity",
  "Streamlines assessments",
  "Reduces administrative burdens",
  "Elevates credibility with fraud-proof testing",
  "Efficient, seamless, secure, and scalable",
];

const EzyTest = () => {
  return (
    <div className="bg-white text-dark  ml-50 mr-50">
      {/* Header Section */}
      <section className=" py-5">
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="fw-bold text-primary fs-3"
        >
          Computer Based Test (CBT)
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className="mt-3 fs-5 text-black"
        >
          Transform your examination process with EzyTest, our cutting-edge
          Computer-Based Testing solution designed to deliver seamless, secure,
          and scalable online assessments. With AI-powered automation, EzyTest
          enables remote proctoring, instant results, and fraud-proof testing,
          saving time and costs while enhancing accuracy.
        </motion.p>
      </section>

      {/* Features Section */}
      <section className=" py-5 px-2">
        <motion.h2
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center fw-bold text-primary mb-4"
        >
          Key Features
        </motion.h2>

        <div className="row g-4">
          {features.map((feature, idx) => (
            <div key={idx} className="col-sm-6 mb-2 col-md-4">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: idx * 0.1 }}
                viewport={{ once: true }}
                className="card shadow-sm border-0 h-100"
              >
                <div className="card-body d-flex align-items-start gap-2">
                  <FaCheckCircle className="text-success mt-1" />
                  <span className="text-black">{feature}</span>
                </div>
              </motion.div>
            </div>
          ))}
        </div>
      </section>

      {/* Exam Centre Surveillance */}
      <section className="container py-5">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="p-4 rounded shadow-sm border-start border-4 border-warning bg-warning bg-opacity-10"
        >
          <h3 className="fw-semibold text-warning mb-3">
            Exam Centre Surveillance
          </h3>
          <p className="text-black">
            Our AI-powered exam surveillance solution eliminates malpractice and
            ensures fairness. It can work as an end-to-end system or integrate
            with existing CCTV infrastructure. Using advanced algorithms for
            real-time monitoring, it flags suspicious activities like
            impersonation, unusual movements, and unauthorized devices.
          </p>
          <p className="text-black">
            Key features include AI-driven live proctoring, multi-camera
            recording, biometric verification, and a cloud dashboard for instant
            alerts & analytics. This automated approach reduces human error and
            administrative burden significantly.
          </p>
        </motion.div>
      </section>

      {/* Advantages Section */}
      <section className=" text-white py-5" style={{ backgroundColor: "#0a1530" }}>
        <div className="container text-center">
          <motion.h2
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="fw-bold display-6"
          >
            Key Advantages
          </motion.h2>
          <div className="row mt-4 g-3 text-start">
            {advantages.map((adv, idx) => (
              <div key={idx} className="col-sm-6 mb-3 col-md-4">
                <motion.div
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: idx * 0.1, duration: 0.6 }}
                  viewport={{ once: true }}
                  className="p-3 rounded bg-white bg-opacity-25 d-flex align-items-start gap-2"
                >
                  <FaCheckCircle className="text-success mt-1" />
                  <span className="text-white" >{adv}</span>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default EzyTest;
